import request from '../../utils/request'
import {API} from '../../utils/constant'

export default {
  getRequest (params) {
    return request.get(API.ADMIN_CONTACT, params)
  },
  detailRequest (params) {
    return request.get(API.ADMIN_CONTACT_GET + params, params)
  },
  deleteRequest (params) {
    return request.delete(API.ADMIN_CONTACT_GET + params)
  },
  createCompany (params) {
    return request.post(API.ADMIN_COMPANY, params)
  },
  updateUserInquiry (params) {
    return request.put(API.ADMIN_USER_INQUIRY + '/' + params.id)
  }
}



// WEBPACK FOOTER //
// ./src/api/admin/request.js